import { DateFormat } from "@/models/share.model";
import { format, lastDayOfMonth, parse } from "date-fns";

class DateService {
    static getFirstDayOfWeek(date: Date, firstDayIsMonday: boolean): Date {
        const day = firstDayIsMonday ? (date.getDay() === 0 ? 6 : date.getDay() -1) : date.getDay();
        const firstDay = new Date(date);
        firstDay.setDate(date.getDate() - day);
        return firstDay;
    }
    
    static getLastDayOfWeek(date: Date, lastDayIsSunday: boolean): Date {
        const lastDay = new Date(date);
        lastDay.setDate(date.getDate() + (lastDayIsSunday ? (date.getDay() === 0 ? 0 : (7  - date.getDay())) : (6 - date.getDay())));
    
        return lastDay;
    }

    static getStringFirstDayofMonth(date: Date): string {    
        return format(date, DateFormat.FIRST_DAY_ISO_SMALL);
    }
    
    static getStringLastDayOfMonth(date: Date): string {
        return format(lastDayOfMonth(date), DateFormat.ISO_SMALL);
    }

    static getFormatOptionMonth(): Intl.DateTimeFormatOptions {
        return {
            year: 'numeric',
            month: 'long'
        };
    }

    static getFormatOptionDay(): Intl.DateTimeFormatOptions {
        return {
            day: 'numeric'
        };
    }

    static getFormatOptionLongDay(): Intl.DateTimeFormatOptions {
        return {
            day: 'numeric',
            weekday: 'long'
        };
    }

    static getWeekDayLongFormat(date: Date, locale = 'fr-FR'): string {
        return new Date(date).toLocaleDateString(locale, { weekday: 'long' });
    }

    static formatTimeWithTimezone(date: string, time: string): string {
        const dateTime = parse(
            `${date} ${time}`,
            DateFormat.ISO_LONG,
            new Date()
        );

        return format(dateTime, DateFormat.TIME_WITH_OFFSET);
    }
}

export default DateService;